/* It's a search bar that filters the forms based on the input */
import React, { Component } from "react"
import DynamicFormTypes from "../Types/DynamicFormsTypes"
import { Button, FormControl, Spinner } from "react-bootstrap"
import stateMutator from "../Utils/StateMutator"
import "./SearchForms.css"

interface Props {
    forms: Array<DynamicFormTypes>
    formsCopy: Array<DynamicFormTypes>
    manageParentState: Function
}

interface State {
    input: string | null
    busy: boolean
}

class SearchForms extends Component<Props, State> {

    typingTimeout: any = 0
    maxSearchStringLength = 300

    state = {
        input: null,
        busy: false
    }

    /* A function that is used to update the state. It is used to prevent the state from being updated in
    an uncontrolled manner. */
    manageState = (keys: Array<{ key: string, value?: any }>) => {
        this.setState(stateMutator.mutate(this.state, keys))
    }

    /* Filtering the forms based on the input. */
    filterforms = (input: string, forms: Array<DynamicFormTypes>) => {
        let temp = []
        for (let i = 0; i < forms.length; i++) {
            let str = Object.values(forms[i])
            for (let j = 0; j < str.length; j++) {
                //@ts-ignore
                if (typeof (str[j]) === "string" && str[j].length > this.maxSearchStringLength) {
                    str[j] = ""
                }
            }
            //@ts-ignore
            str = str.join().toLowerCase()
            if (str.includes(input)) {
                temp.push(forms[i])
            }
        }
        this.props.manageParentState([{ key: "forms", value: temp }])
        this.manageState([{ key: "busy", value: false }])
    }

    /* A debounce function. */
    debounce = (event: { target: { value: string } }) => {
        const input = event.target.value.toLowerCase()
        this.manageState([{ key: "input", value: input }, { key: "busy", value: true }])
        if (this.typingTimeout) {
            clearTimeout(this.typingTimeout);
        }
        this.typingTimeout = setTimeout(() => {
            if (input.length > 0) {
                this.filterforms(input, this.props.formsCopy)
            } else {
                this.props.manageParentState([{ key: "forms", value: this.props.formsCopy }])
                this.manageState([{ key: "busy", value: false }])
            }
        }, 500)
    }

    render() {

        const state = this.state
        const props = this.props

        // console.log("df_SearhForms props", props)
        // console.log("df_SearhForms state", state)

        return (
            <div className="SearhForms">
                <div className="SearchFormsInput">
                    <FormControl
                        onChange={this.debounce}
                        placeholder={"Search forms"}
                        value={this.state.input || ""}
                        type="text"
                    />
                </div>
                <div className="SearchFormsBusy">
                    {state.busy && <Spinner id="search-forms-busy-spinner" animation="border" />}
                </div>
                {state.input && props.forms.length === 0 && <div className="SearchFormsNoFormsFound">
                    <span className="SearchFormsNoFormsFoundErrEmoji">{`(>_<)`}</span>
                    <p>{`No forms found for "${state.input}"`}</p>
                    <Button variant="secondary" onClick={() => this.debounce({ target: { value: "" } })}>Reset your filters and try again?</Button>
                </div>}
            </div>
        )
    }
}

export default SearchForms